const SITE_URL = 'https://gigafish.co'

export const organizationSchema = {
  '@context': 'https://schema.org',
  '@type': 'Organization',
  name: 'Gigafish',
  url: SITE_URL,
  logo: `${SITE_URL}/assets/gigafish-brandmark.svg`,
  description:
    'Full-service digital agency helping challenger brands outmaneuver, outpace, and outgrow the competition.',
  address: {
    '@type': 'PostalAddress',
    addressLocality: 'Perth',
    addressRegion: 'WA',
    addressCountry: 'AU',
  },
  sameAs: [],
  contactPoint: {
    '@type': 'ContactPoint',
    email: 'hello@gigafish.co',
    contactType: 'sales',
  },
}

export const webSiteSchema = {
  '@context': 'https://schema.org',
  '@type': 'WebSite',
  name: 'Gigafish',
  url: SITE_URL,
}

export function breadcrumbSchema(items: { name: string; path: string }[]) {
  return {
    '@context': 'https://schema.org',
    '@type': 'BreadcrumbList',
    itemListElement: [
      { '@type': 'ListItem', position: 1, name: 'Home', item: SITE_URL },
      ...items.map((item, i) => ({
        '@type': 'ListItem',
        position: i + 2,
        name: item.name,
        item: `${SITE_URL}${item.path}`,
      })),
    ],
  }
}

export function serviceSchema(service: {
  name: string
  description: string
  path: string
}) {
  return {
    '@context': 'https://schema.org',
    '@type': 'Service',
    name: service.name,
    description: service.description,
    url: `${SITE_URL}${service.path}`,
    provider: {
      '@type': 'Organization',
      name: 'Gigafish',
      url: SITE_URL,
    },
    areaServed: {
      '@type': 'Country',
      name: 'Australia',
    },
  }
}

export function webPageSchema(page: {
  name: string
  description: string
  path: string
}) {
  return {
    '@context': 'https://schema.org',
    '@type': 'WebPage',
    name: page.name,
    description: page.description,
    url: `${SITE_URL}${page.path}`,
    isPartOf: { '@type': 'WebSite', url: SITE_URL },
  }
}
